'use strict';

exports.__esModule = true;
exports.useReversedNumbers = useReversedNumbers;
/**
 * Returns whether a reverse number order is used
 * @param {number} start
 * @param {number} end
 * @returns {boolean} Returns a boolean
 */
function useReversedNumbers(start, end) {
  return typeof start === 'number' && typeof end === 'number' && start > end;
}